import { Injectable } from '@angular/core';
import { Diffuseur } from '../../../models/diffuseur';
import { Endpoints } from '../../../models/endpoints';
import { Constants } from '../../shared/generic/models/constants';
import { HttpService } from '../../shared/services/http.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';


@Injectable({
    providedIn: 'root',
})
export class DiffuseurService {

    constructor(private http: HttpService) { }

    public isBOAMPSelected(parentForm): boolean {
        let isBoamp = false;
        const diffFormGrp: any = parentForm.get(Constants.TABLE_DATA_CTRL_NAME);
        const diffsCtrl: any = diffFormGrp.controls;
        Object.keys(diffsCtrl).forEach((key) => {
            if (diffsCtrl[key].controls.zonediffusion.value === 'NATIONAL') {
                if (diffsCtrl[key].controls.checked.value === true) {
                    isBoamp = !diffsCtrl[key].controls.checked.value;
                }
            }
        });
        return isBoamp;
    }

    /**
     * Cette fonction permet de vérifier si l'un des diffuseurs (JOUE ou BOAMP est séléctionné)
     * @param parentForm
     * @returns
     */
    public isBOAMPOrJoueSelected(parentForm): boolean {
        let isJoueOrBoamp = false;
        const diffFormGrp: any = parentForm.get(Constants.TABLE_DATA_CTRL_NAME);
        const diffsCtrl: any = diffFormGrp.controls;
        Object.keys(diffsCtrl).forEach((key) => {
            if (diffsCtrl[key].controls.zonediffusion.value === 'NATIONAL' ||
                diffsCtrl[key].controls.zonediffusion.value === 'EUROPE') {
                if (diffsCtrl[key].controls.checked.value === true) {
                    isJoueOrBoamp = !diffsCtrl[key].controls.checked.value;
                }
            }
        });
        return isJoueOrBoamp;
    }

    public getBoampAndJoueIds(): Observable<number[]> {
        return this.http.get<Diffuseur[], Diffuseur>(Endpoints.DIFFUSEUR_FIND_BOAMP_JOUE, Diffuseur).pipe(map(dfs => dfs.map(df => df.id)));
    }
}
